<template>
    <b-card :class="{'d-flex flex-row':true}" no-body>
        <router-link :to="{path : '/users/list/' + data.data.attributes.user_id}" class="d-flex">
            <img :src="'/storage/images/users/' + data.data.attributes.image" class="list-thumbnail responsive border-0"
                 style="object-fit: cover; max-width: 100px;"
                 :alt="data.data.attributes.name"/>
        </router-link>

        <div class="pl-2 d-flex flex-grow-1 min-width-zero">
            <div
                class="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                <router-link :to="{path : '/hms/users/list/' + data.data.attributes.user_id}" class="w-40 w-sm-100">
                    <p class="list-item-heading mb-0 truncate">{{data.data.attributes.name}}</p>
                    <b-card-text class="text-muted text-small">{{data.data.attributes.position}}</b-card-text>
                </router-link>

                <p class="mb-0 text-muted text-small w-30 w-sm-100" title="Assigned by">{{data.data.attributes.assigned_by}}</p>

                <p class="mb-0 text-muted text-small w-15 w-sm-100" title="Assigned on">{{data.data.attributes.assigned_on}}</p>
            </div>

            <div class="custom-control custom-checkbox pl-1 align-self-center pr-4">
                <b-button size="xs" variant="info" @click="$emit('unassign', data)">Unassign</b-button>
            </div>
        </div>
    </b-card>
</template>

<script>
    export default {
        props: ['data'],
    }
</script>
